module.exports = __webpack_public_path__ + "assets/microsoft-aspnet.dc7ae52d.svg";